module.exports = __webpack_public_path__ + "media/images/type2-928dae3b343262b63f70e9e7ac20addb.png";